import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        cardContent: {
            marginBottom: theme.spacing(2),
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        tableWrapper: {
            maxHeight: '600px',
        },
    }
})

export default useStyles
